<template>
  <nav class="main-nav">
    <div class="dropdown">
                    <div class="dropdown-label">
                      <div class="humburger">
                        <div class="humburger-item"></div>
                        <div class="humburger-item"></div>
                        <div class="humburger-item"></div>
                      </div>
                    </div>
                    <div class="dropdown-menu">
                        <ul class="submenu">
                            <li><a class="nav-link" href="/">На главную</a></li>
                            <li><a class="nav-link" href="/Tasks">Миссии</a></li>
                            <li><a class="nav-link" :href="'/Users/Info/'+userId">Профиль</a></li>
                            <li><a class="nav-link" href="/Users/Logout">Выход</a></li>
                        </ul>
                    </div>
    </div>
    <!-- <span style="margin-left: 1em" class="image-name">{{ imageName }}</span> -->
    <div class="tooltip">
        <span style="margin-left: 0.4em" class="image-name">{{ imageName }}</span>
        <span class="tooltiptext">'{{missionGroupName}}', изображение: '{{ imageName }}'</span>
      </div>
    <button class="tool-button"  v-if="editorEnabled && !isEditable" @click="enableEditor">Включить редактирование</button>
    <ToolButtons v-if="isEditable && navBarActive && !drawingsOn && !neuralOn" @editor-is-enabled="showSaveButton" :editorEnabled="editorEnabled"/>
    <category-chooser />
    <button style="margin-left: auto; margin-right: 1em;" class="tool-button main-button"  v-if="editorEnabled && navBarActive" @click="save">Сохранить</button>
    <div v-if="!navBarActive" style="margin-left:auto;margin-right:auto">Режим заметки</div>
    <div v-if="!(editorEnabled && navBarActive)" class="auto-left"></div>
    <a class="nav-link" :href="'/Users/Info/'+userId">{{ userName }}</a>
  </nav>
</template>

<script>
import ToolButtons from "./ToolButtons.vue";
import CategoryChooser from "./CategoryChooser.vue";
export default {
  data() {
    return {
      canSave : false,
    }
  },
  props: {
    navBarActive:{
      type:Boolean,
      required:true,
    },
    imageName: {
      type: String,
      required: true,
    },
    missionGroupName: {
      type: String,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
    editorEnabled: {
      type: Boolean,
      required: true,
    },
    neuralOn: {
      type: Boolean,
      required: true,
    },
    drawingsOn: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: Number,
      required: true
    }
  },
  components: {
    ToolButtons,
    CategoryChooser
  },
  emits : ["save-markup", "editor-is-enabled"],
  methods : {
    showSaveButton(){
      this.canSave = true;
      this.$emit("editor-is-enabled");
    },
    save(){
      this.$emit("save-markup");
    },
    enableEditor(){
      this.$services.eventAggregator.fire("enableeditor");
    }
  }
};
</script>

<style scoped>
.main-nav {
  height: 2rem;
  display : flex;
  align-items: center;
  margin: 0;
} 
.auto-left {
  margin-left: auto;
}
.dropdown {
    display: inline-block;
    position: relative;
    z-index: 1001;
}
.dropdown-label {
    padding: 0 0.25em 0 0.25em;
    border: 1px solid #ccc;
    background-color: #eee;
}

.dropdown:hover .dropdown-label::after {
    top: 0.7em;
    border-color: transparent transparent black;
}

.dropdown-menu {
    display: none;
    position: absolute;
    left: 0;
    top: 2.1em;
    min-width: 16rem;
    background-color: #eee;
}
.dropdown:hover .dropdown-menu {
    display: block;
}
.submenu {
    padding-left: 0;
    margin: 0;
    list-style-type: none;
    border: 1px solid #999;
}
.submenu > li + li {
    border-top: 1px solid #999;
}
.submenu > li > a {
    display: block;
    padding: 0.5em 1.5em;
    background-color: #eee;
    color: #369;
    text-decoration: none;
}
.submenu > li > a:hover {
    background-color: #fff;
}
.object-info-flex {
  display: flex;
}
.humburger{
  width: 2rem;
  height: 2em;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.humburger-item{
  height: 4px;
  margin: 0 0.2rem;
  background-color: black;
  border-radius: 0.2rem;
}
</style>